import { useMutation, useQueryCache } from "react-query";
import { _t } from "../../../../../modules/Common/components/InjectIntlContext";
import { notify } from "../../../../../common/helpers";
import {
  API_KEY_GET_MANAGEABLE_LIST,
  API_KEY_GET_MANAGEABLE_LIST_ITEM,
} from "../constants";
import { postManageableListItemSend } from "../api/postManageableListItemSend";

export const usePostManageableListItemSend = (id) => {
  const queryCache = useQueryCache();
  const successMsg = _t("successfully_updated");

  return useMutation(postManageableListItemSend, {
    onSuccess: (data, variables) => {
      notify("success", successMsg);
      queryCache.invalidateQueries(API_KEY_GET_MANAGEABLE_LIST);
      queryCache.invalidateQueries([API_KEY_GET_MANAGEABLE_LIST_ITEM, id]);
    },
  });
};
